/**
 * @typedef {string} apiUrlPath
 */
/**
 * @typedef {string} apiOp
 */
/**
 * @typedef {Object} requestData
 */
/**
 * @typedef {'POST'|'GET'} queryMethod
 */

/**
 * @typedef {function(data: Object, statusCode: Number, xhr: Object, dataraw: any )} SuccessCallbackFunction
 */
/**
 * @typedef {function(data: Object, statusCode: Number, xhr: Object, reqestObject: any )} ErrorCallbackFunction
 */

/**
 * @typedef seApiSrvInst
 * @property {function} queryFile
 * @property {function} asyncOff  toggles async mode to be OFF
 * @property {seApiSrvFnQuery} query
 * @property {function} queryText
 * @property {function} queryXml
 * @property {function} queryForm
 * @property {seApiSrvFnParse} parse
 * @property {function} setHeader
 *
 * @property {ApiError} ApiError
 *
 * @property {Boolean} _WINDOW_IS_UNLOADING
 */

/**
 * @callback SeApiService
 * @param {Object} ENV  SeApp Environment
 * @param _ lodash
 * @param seLogging
 * @param connectionStatus
 * @param {jQuery} _jQ
 * @return {seApiSrvInst}
 * @constructor
 */

!function (factory) {
  if (typeof module !== 'undefined') { module.exports = factory } else {
    define('app/services/seApiSrv',[
      'app.env',
      'lodash',

      'app/helper/logging.se',
      'app/helper/connectionstatus.se',
      'app/helper/events.se',
      'jquery'
    ], factory)
  }
}(
  /**
   * @type SeApiService
   */
  function (
    ENV,
    _,
    seLogging,
    connectionStatus,
    seEvents,
    _jQ
  ) {

    var LOG_LABEL = 'API SRV'

    // IE9 FormData fix
    var FormData = window.FormData
    if (typeof (FormData) === 'undefined') {
      var FormData = null
    }

    var $ = window.$ || _jQ

    var PAGE_IS_UNLOADING
    window.addEventListener('beforeunload', function () {
      PAGE_IS_UNLOADING = true
    })

    var ApiError = (function () {
      var ApiError = function (message, details) {
        // based on https://stackoverflow.com/a/21693276/2182191
        var err = new Error(message)
        err.name = 'ApiError'

        var _this = this
        Object.keys(err).map(function (k) {
          _this[k] = err[k]
        })

        this.name = err.name
        this.message = err.message
        this.details = details
        //check if there is a stack property supported in browser
        if (err.stack) {
          this.stack = err.stack
        }
        //we should define how our toString function works as this will be used internally
        //by the browser's stack trace generation function
        this.toString = function () {
          return this.name + ': ' + this.message + '; ' + JSON.stringify({
            details: details,
            logs: err.stack
          })
        }
      }
      ApiError.prototype = new Error()
      ApiError.prototype.name = 'ApiError'

      return ApiError
    }())

    var _v = {
        requestDefaultParams: {
          method: 'POST',
          headers: {
            //'X-Auth-Token': 'T1eyaTLvc79Q3SbmKBnFDztMW8GCEJ', // demo server TOKEN
            //'Content-Type': 'application/json',
            //'Accept': 		'application/json'
          },
          timeout: ENV.async_timeout_seconds * 1000,
          data: null, // will be overwritten
        },
        customHeaders: {},
        apiModeAsync: true,
        windowIsUnloading: false
        //_tokenDb: 'seApi'
      },
      _fn = {
        util: {
          /**
           * convert data object into uri parameter string, e.g. {a: "b c d", 2: 345} => a=b%20c%20d&2=345
           * @param data
           * @returns {string}
           */
          objToUrlParam: function (data) {
            var paramstr = ''

            for (var i in data) {
              if (!data.hasOwnProperty(i))
                continue

              if (paramstr.length > 0)
                paramstr += '&'

              paramstr += i + '=' + encodeURIComponent(data[i])
            }

            return paramstr

          }
        },
        prepReq: function (uri, method, op, params, format, progressCb) {
          var req = _.clone(_v.requestDefaultParams, true),
            data

          if (params && params.req) {
            req = _.merge(req, params.req)
            delete (params.req)
          }

          req.op = op

          req.headers = _.clone(_.merge(req.headers, _v.customHeaders), true)
          _v.customHeaders = {}

          method = method ? method.toString().toUpperCase() : ''

          switch (method) {
            case 'POST':
            case 'DELETE':
            case 'PUT':
            case 'GET':
              // do nothing -- everything is already purrrrfect.
              break
            default :
              method = 'GET'
              break
          }
          req.method = method

          // extract params from uri and merge with params object
          var uriInfo = uri.split('?'),
            uriBase = uriInfo[0],
            uriParams = (uriInfo[1] || '').split('&').reduce(function (r, v) {
              var p = v.split('=')
              r[p[0]] = decodeURIComponent(p[1])
              return r
            }, {})

          if (params) {
            // adding operation to data set
            if (op) {
              if (typeof params.append == 'function') {
                params.append('op', op)
              } else {
                params.op = op
              }
            }

            if (params.constructor && params.constructor === FormData) {
              data = params

            } else if (params.data) {
              data = params.data
              delete (params.data)

              _.merge(uriParams, params)
            } else {
              data = params
            }
          }

          var uriSearch = []
          _.each(uriParams, function (val, key) {
            if (key)
              uriSearch.push(key + '=' + encodeURIComponent(val))
          })
          var uriSearchStr = uriSearch.join('&')
          req.url = uriBase + '?' + uriSearchStr

          //console.log('prep req', 'uriParams', uriParams, req.url)

          req.data = data

          format = format ? format.toString().toLowerCase() : format
          switch (format) {
            case 'json':
            case 'xml':
            case 'text':
              // do nothing -- everything is already purrrrfect.
              break
            case false:
              if (format === false) { break }
            default:
              format = 'json'
              break
          }
          req.dataType = format

          if (progressCb) {
            req.xhr = function () {  // Custom XMLHttpRequest
              var myXhr = $.ajaxSettings.xhr()
              if (myXhr.upload) { // Check if upload property exists
                myXhr.upload.addEventListener('progress', progressCb, false) // For handling the progress of the upload
              }
              return myXhr
            }

            req.processData = false
            req.contentType = false
          }

          // disable cache
          req.cache = false
          if (req.url.indexOf('?') != -1) {
            req.url += '&_=' + Date.now()
          } else {
            req.url += '?_=' + Date.now()
          }

          return req

        },
        query: function (req, successCb, errorCb) {
          var op = req.op

          errorCb = errorCb || function () {}

          console.log(LOG_LABEL, 'req', req)

          if (req.data) {
            switch (req.method) {
              case 'GET':
              case 'HEAD':
              case 'DELETE':

                if (req.url.match(/\?/)) {
                  req.url += '&' + _fn.util.objToUrlParam(req.data)
                } else {
                  req.url += '?' + _fn.util.objToUrlParam(req.data)
                }
                delete (req.data)

                break
              case 'POST':
              case 'PUT':
              default:

                if (req.dataType === 'json') {
                  req.headers['Content-Type'] = 'application/json'
                  req.data = JSON.stringify(req.data)
                }

                break
            }
          }

          req._apiCallRes = $.Deferred()

          var apiCall = function (retrying) {
            retrying = retrying || 0

            req.success = function (data, status, xhr) {
              if (xhr.status !== 200) {
                console._error(LOG_LABEL, {
                  log: data.message,
                  url: req.url,
                  data: data,
                  status: status,
                  xhr: xhr
                })
                req.error(xhr, status, data)
                return false
              }

              _fn.emitSuccess(op, data, xhr)

              req._apiCallRes.resolve(data)

              successCb(data, status, xhr)
            }

            req.error = function (xhr, status, errorMsg) {
              var statusCode = +xhr.status,
                errorData = {
                  code: statusCode,
                  status: status,
                  message: errorMsg
                },
                errObj = new ApiError(
                  errorData.message || 'error on api call',
                  {
                    req: req,
                    headers: xhr.getAllResponseHeaders(),
                    res: errorData
                  }),
                doLogError = false

              _fn.emitError(op, errObj, statusCode, xhr)

              switch (statusCode) {
                // UNCLEAR, no server response
                case 0:
                  // this is normally a browser-blocked request e.g. on unload or on cross-domain
                  // or a timeout

                  if (PAGE_IS_UNLOADING) {
                    // do not react if this is due to request canceled before answered (e.g. page is left while waiting for answer)
                    console.warn(LOG_LABEL, 'api returned error status code ZERO', xhr, errorMsg)

                    return // --> ignored

                  }

                // otherwise treat it like a timeout
                // TIMEOUT
                case 408: // Server timeout
                case 504: // Gateway timeout
                  errorData.code = 504

                  if (ENV.max_async_retries <= 0 || (retrying && retrying >= ENV.max_async_retries)) {

                    connectionStatus.setStatus(connectionStatus._CON.FAILED)
                    seLogging.error(errObj)

                    errorData.status = 'timeout'

                  } else {

                    connectionStatus.setStatus(connectionStatus._CON.LOST)
                    connectionStatus.onReconnect(function () { apiCall(retrying + 1) })
                    connectionStatus.onFail((function (errorData, errorCb, xhr, req) {
                      return function () {
                        errorData.status = 'timeout'
                        errorCb(errorData, errorData.code, xhr, req)
                      }
                    }(errorData, errorCb, xhr, req)))

                    errorData.status = 'retry'

                  }

                  break

                case 423: // locked
                  // retry call max_async_retries times
                  if (ENV.max_async_retries > 0 && retrying < ENV.max_async_retries) {

                    setTimeout(function () {
                      apiCall(retrying + 1)
                    }, 1000) // retry fast, dont wait async_timeout_s

                    return // stop error here.
                  }

                  break

                // LIMITS - handled on app.view level via seEvents
                case 403: // forbidden, e.g. limit reached
                case 412: // limit reached
                  break;

                // RECOVERABLES - to be handled by frontend / user interaction
                case 409: // conflict
                case 410: // gone
                  break;

                // ERROR
                case 404: // Not found
                  connectionStatus.setStatus(connectionStatus._CON.FAILED)
                case 500:
                default: // = IN ANY OTHER CASE -> do log error and show a toasty
                  doLogError = true
                  break
              }


              errorCb(errorData, errorData.code, xhr, req)
              if (doLogError) {
                // call after errorCb to allow errorCb to show an error toasty first (only first error toasty is shown)
                // this is a logging and a generic toasty fallback
                seLogging.error(errObj)
              }
            }

            if (!_v.apiModeAsync) {
              req.async = false
            }

            $.ajax(req)

          }

          apiCall()

        },
        parseContextResponse: function (dataraw, params) {
          var data = ''

          try {
            if (_.isObject(dataraw))
              data = dataraw
            else if (_.isString(dataraw) && dataraw.length > 0)
              data = JSON.parse(dataraw)

          } catch (err) {
            console.error(LOG_LABEL, { error: 'bad parsing', expt: err, data: dataraw })
          }

          //console.log(LOG_LABEL, 'parse result', dataraw, data);

          return data
        },
        emitError: function (op, errorData, status, xhr) {
          seEvents.emit('error:api', {
            op: op,
            data: errorData,
            status: status,
            xhr: xhr
          })
        },
        emitSuccess: function (op, data, xhr) {
          seEvents.emit('api', {
            op: op,
            data: data,
            xhr: xhr
          })
        }
      },
      fn = {
        ApiError: ApiError,
        _WINDOW_IS_UNLOADING: false,
        asyncOff: function () {
          _v.apiModeAsync = false
        },
        setHeader: function (key, val) {
          _v.customHeaders[key] = val

          return _.clone(_v.customHeaders, true)
        },
        /**
         * @callback seApiSrvFnParse
         * tries to JSON.parse if dataraw is string or returns dataraw if is already an object
         * @param {Object|String} dataraw
         * @param {Object} [params]
         * @return {Object}
         */
        /**
         * @type seApiSrvFnParse
         */
        parse: function (dataraw, params) {
          return _fn.parseContextResponse(dataraw, params)
        },
        /**
         * @callback seApiSrvFnQuery
         * @param {String} uri
         * @param {queryMethod} method    defaults to GET
         * @param {apiOp} op        added to the URI params as 'op=VAL'
         * @param {requestData} params    additional query parameters
         * @param {SuccessCallbackFunction} [succCb]  success callback function
         * @param {ErrorCallbackFunction} [errCb]  error callback function
         * @return Promise
         */
        /**
         * @type seApiSrvFnQuery
         */
        query: function (uri, method, op, params, succCb, errCb) {
          var
            req = _fn.prepReq(uri, method, op, params),
            _res = $.Deferred(),
            _succCb = function (data, status, xhr, dataraw) {
              _res.resolve({
                data: data,
                status: status,
                xhr: xhr,
                dataraw: dataraw
              })

              succCb && succCb.apply(this, arguments)
            },
            _errCb = function (errorData, code, xhr, req) {
              _res.reject({
                data: errorData,
                code: code,
                xhr: xhr,
                req: req
              })
              errCb && errCb.apply(this, arguments)
            }

          _fn.query(req, function (dataraw, status, xhr) {
            var data = _fn.parseContextResponse(dataraw)
            _succCb(data, status, xhr, dataraw)
          }, _errCb)

          return _res.promise()
        },
        queryXml: function (uri, method, op, params, succCb, errCb) {
          var req = _fn.prepReq(uri, method, op, params, 'xml')

          _fn.query(req, function (dataraw, status, xhr) {
            succCb(_fn.parseContextResponse(dataraw), status, xhr, dataraw)
          }, errCb)
        },
        queryText: function (uri, method, op, params, succCb, errCb) {
          var req = _fn.prepReq(uri, method, op, params, 'text')

          _fn.query(req, function (dataraw, status, xhr) {
            succCb(dataraw, status, xhr)
          }, errCb)
        },
        queryFile: function (uri, method, op, formdata, succCb, errCb, progressCb) {

          progressCb = progressCb || function () {} // important > triggers the file mode.

          var req = _fn.prepReq(uri, method, op, formdata, 'text', progressCb)

          _fn.query(req, function (dataraw, status, xhr) {
            succCb(dataraw, status, xhr)
          }, errCb)

        },
        queryForm: function (uri, method, op, formdata, succCb, errCb) {

          var xhr = new XMLHttpRequest()
          var FD = new FormData()

          if (formdata.constructor === FormData) {
            FD = formdata
          } else {
            _.forEach(formdata, function (val, key) {
              FD.append(key, val)
            })
          }

          FD.append('op', op)

          xhr.timeout = _v.requestDefaultParams.timeout

          // We define what will happen if the data are successfully sent
          xhr.addEventListener('load', function () {
            var data = xhr.response
            _fn.emitSuccess(op, data, xhr)
            succCb(data, xhr.status, xhr)
          })

          // We define what will happen in case of error
          xhr.addEventListener('error', function err (err) {
            _fn.emitError(op, err.message, xhr.status, xhr)
            errCb(err.message, xhr.status, xhr, null)
          })

          // We setup our request
          xhr.open(method, uri)

          // We just send our FormData object, HTTP headers are set automatically

          xhr.send(FD)

        }
      }

    return fn

  }
);
